(function () {
  'use strict';

  var container = document.querySelector('[data-products-container]');
  if (!container || window.location.pathname.indexOf('/collections/') !== 0) {
    return;
  }

  var initialUrl = new URL(window.location.href);
  var initialPage = parseInt(initialUrl.searchParams.get('page') || '1', 10);

  if (!Number.isFinite(initialPage) || initialPage !== 1) {
    return;
  }

  var leavingForProduct = false;
  var framePending = false;

  function collectionRows() {
    return Array.from(container.children).filter(function (child) {
      return child.classList && child.classList.contains('row');
    });
  }

  function visiblePage() {
    var rows = collectionRows();
    if (!rows.length) return 1;

    var marker = window.innerHeight * 0.4;
    var page = 1;

    rows.forEach(function (row, index) {
      if (row.getBoundingClientRect().top <= marker) {
        page = index + 1;
      }
    });

    return page;
  }

  function historyUrl(page) {
    var url = new URL(window.location.href);
    url.searchParams.delete('section_id');

    if (page > 1) {
      url.searchParams.set('page', String(page));
    } else {
      url.searchParams.delete('page');
    }

    return url.pathname + url.search + url.hash;
  }

  function syncUrl() {
    framePending = false;
    if (leavingForProduct) return;

    var target = historyUrl(visiblePage());
    var current = window.location.pathname + window.location.search + window.location.hash;

    if (target !== current) {
      history.replaceState(history.state, '', target);
    }
  }

  function scheduleSync() {
    if (framePending || leavingForProduct) return;
    framePending = true;
    window.requestAnimationFrame(syncUrl);
  }

  function isSameTabProductNavigation(event, link) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return false;
    }

    if (link.hasAttribute('download')) return false;
    if (link.target && link.target.toLowerCase() !== '_self') return false;
    if (event.target.closest('[data-quickview-action]')) return false;

    try {
      var targetUrl = new URL(link.href, window.location.origin);
      return targetUrl.origin === window.location.origin && targetUrl.pathname.indexOf('/products/') === 0;
    } catch (error) {
      return false;
    }
  }

  function protectBackRestoration(event) {
    var link = event.target.closest && event.target.closest('a[href*="/products/"]');
    if (!link || !container.contains(link) || !isSameTabProductNavigation(event, link)) {
      return;
    }

    leavingForProduct = true;

    var baseUrl = new URL(window.location.href);
    baseUrl.searchParams.delete('page');
    baseUrl.searchParams.delete('section_id');

    history.replaceState(
      history.state,
      '',
      baseUrl.pathname + baseUrl.search + baseUrl.hash
    );
  }

  window.addEventListener('scroll', scheduleSync, { passive: true });
  window.addEventListener('resize', scheduleSync);
  document.addEventListener('click', protectBackRestoration, true);

  var observer = new MutationObserver(scheduleSync);
  observer.observe(container, { childList: true });

  window.addEventListener('pageshow', function () {
    leavingForProduct = false;
    scheduleSync();
  });

  scheduleSync();
})();
